<template>
  <div class="tips-box-wrap" v-if="showQa">
    <div class="flex">
      <p class="label">若您对该{{ title }}还有其他疑问，如:</p>
      <div class="info" v-if="paInfo">
        <span class="person-name" :title="paInfo.userName">{{
          paInfo.userName
        }}</span>
        <span class="ml-10 flex align-center" v-if="paInfo">
          <i class="icon-dianhua iconfont" style="font-size: 20px"></i>
          <span
            class="person-mobile"
            :title="paInfo.mobilePhone || paInfo.telePhone"
            >{{ paInfo.mobilePhone || paInfo.telePhone }}</span
          >
        </span>
      </div>
    </div>
    <div class="tips-box">
      <template v-for="qa in QaList">
        <dl :key="qa.key" v-if="qa.show">
          <dt>Q：{{ qa.qString }}</dt>
          <dd>
            <span>A：</span>
            <span class="blur-text">{{ qa.aString }}</span>
          </dd>
        </dl>
      </template>
    </div>
    <div class="flex mt-20">
      <p class="label">可以联系我们的PA，PA会竭尽全力帮您成单哟！</p>
      <div class="info" v-if="paInfo">
        <span class="person-name" :title="paInfo.userName">{{
          paInfo.userName
        }}</span>
        <span class="ml-10 flex align-center" v-if="paInfo">
          <i class="icon-dianhua iconfont" style="font-size: 20px"></i>
          <span
            class="person-mobile"
            :title="paInfo.mobilePhone || paInfo.telePhone"
            >{{ paInfo.mobilePhone || paInfo.telePhone }}</span
          >
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showQa: false,
    };
  },
  props: {
    QaList: {},
    hiddenObj: {},
    paInfo: {},
    title: {
      default: "职位",
    },
  },
  computed: {},
  methods: {
    formatQaList() {
      const hiddenObj = this.hiddenObj || null;
      this.QaList.forEach((item) => {
        if (hiddenObj) {
          item.show = !hiddenObj[item.key] || false;
          if (item.key == "benefitsVisible") {
            item.show =
              !hiddenObj["socialSecurityBenefitsVisible"] ||
              !hiddenObj["housingBenefitsVisible"] ||
              !hiddenObj["holidayBenefitsVisible"] ||
              !hiddenObj["phoneTrafficBenefitsVisible"] ||
              !hiddenObj["workOverCostVisible"] ||
              !hiddenObj["workOverCostRuleVisible"] ||
              false;
          }
        } else {
          item.show = true;
        }
      });
      this.showQa = this.QaList.some((i) => i.show == true);
    },
  },
  watch: {},
  created() {
    this.formatQaList();
  },
};
</script>
<style lang="scss" scoped rel="stylesheet/scss">
.tips-box-wrap {
  background-color: #f9f6f2;
  margin-right: 20px;
  border-radius: 4px;
  padding: 16px 12px;
  .label {
    font-weight: bold;
  }
  .info {
    margin-left: auto;
    display: flex;
    align-items: center;
    margin-top: 10px;
  }
  .tips-box {
    margin: 8px 0;
    dl {
      margin-bottom: 16px;
      dt,
      dd {
        display: flex;
        line-height: 28px;
        white-space: pre-line;
        align-items: flex-start;
      }
      .blur-text {
        filter: blur(4px);
        user-select: none;
      }
    }
  }
}
</style>
